<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'Planning',
  }
</script>

<style scoped>

</style>
